import image from '../../assets/images/promos/marketing-tout.jpg'
import imageWebP from '../../assets/images/promos/marketing-tout.webp'

export default {
  gaAction: 'marketing tout cta',
  smallHeadingText: 'THE EASIEST WAY TO SAVE',
  headingText: 'Become an Email Insider',
  contentText:
    'Unlock exclusive coupons, early access to sales and more when you sign up for Priceline emails',
  image,
  imageWebP,
  imageSize: '524px 322px',
  buttons: [
    {
      gaLabel: 'email sign up',
      buttonText: 'Sign Up',
      linkUrl: 'https://www.priceline.com/partner/email/signup'
    }
  ]
}
